import React, { useEffect, useState } from "react";
import Params from "../../../../Sections/ElementsSections/Params";
import { handleParameters } from "../../../../Tools/Requests";
import { Prefixes } from "../../../../Tools/ProjectX";
import clsx from "clsx";
import styles from "../dialogStyles.module.css";
import { PermissionFlags } from "../../../../../ComponentInterface";

interface ParamsForTabsProps {
  props: {
    Module: Prefixes;
    selectedRecordID?: string;
    Token: string;
    Path: string;
    Items?: Array<any>;
    rights?: PermissionFlags;
  };
}

/**
 * Возвращает контент для вкладки параметров
 *
 * Поля компонента:
 *    1. [data, setData] - состояние параметров
 *
 * @param {Object} [props]
 * @param {string} [props.Module] модуль для вкладки параметров
 * @param {string} [props.Path] путь для вкладки параметров
 * @param {string} [props.Token] Заголовок запроса для вкладки параметров
 * @param {string} [props.Items] данные для таблицы параметров
 * @param {string} [props.kladr] использование классификатора адресов
 * @param {string} [props.selectedRecordID] выбранная запись из основной таблицы
 * @returns Возвращает контент для вкладки параметров
 */
export default function ParamsForTabs({ props }: ParamsForTabsProps) {
  const { Module: module, Path: path, Token: token, Items: items, selectedRecordID, rights } = props;
  const [data, setData] = useState<any>();

  /**
   * Загрузка параметров
   */
  const loadParams = async () => {
    if (items) {
      setData(props);
      return;
    }
    setData({ ...props, ...(await handleParameters(module, props, selectedRecordID)) });
  };
  useEffect(() => {
    loadParams();
  }, [selectedRecordID]);

  return (
    <div className={clsx(styles.fullDialogSpaceContainer)}>
      {data?.Items?.length && (
        <Params
          Module={module}
          reqCommand={token}
          GroupID={selectedRecordID}
          Path={path}
          data={data}
          NoHistory={true}
          NoTitle={true}
          NoClearState={true}
          NoSaveSample={true}
          noEdit={rights?.modify === false}
        />
      )}
    </div>
  );
}
